import React from 'react'

import css from '@styled-system/css'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import IconBase, { Path } from '@/components/IconBase'

const directions = ({ isRtl } = {}) => ({
  left: isRtl ? 270 : 90,
  right: isRtl ? 90 : 270,
  up: 180,
  down: 360,
  leftUp: isRtl ? 315 : 45,
  angel: 45,
})
const ArrowBox = styled(IconBase)(({ $direction, theme: { isRtl } }) =>
  css({
    svg: {
      transition: '0.3s',
      transform: `rotate(${directions({ isRtl })?.[$direction] ?? 0}deg)`,
    },
  }),
)

function ArrowLine({
  color = 'icon.arrowBlue',
  direction = 'down',
  stroke = 1.5,
  ...props
}) {
  return (
    <ArrowBox viewBox='0 0 13 15' $direction={direction} {...props}>
      <Path
        d='M6.42738 1.23165L6.52207 13.8526'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M1.5 6.13281L6.42583 1.22964L11.3994 6.08584'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
    </ArrowBox>
  )
}

ArrowLine.propTypes = {
  direction: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.number,
}

export default ArrowLine
